module.exports = __webpack_public_path__ + "static/feriados-ba391b7674c75b83d2d65fafac3c5a69.gif";